import { createApp } from "vue";
import Router from "@/router/Router";
import ConvertFormats from "@/ConvertFormats.vue";

createApp(ConvertFormats).use(Router).mount("#convertformats");
